export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6428.d552adc5.jpg";